import ApiResponse from "../models/ApiResponse";
import {
  MatrixConfigurationResponse,
  MatrixExportConfigurationResponse,
  TestRequestMatrixExportConfigurationRequest,
  TestSeriesMatrixExportConfigurationRequest,
} from "../models/test-series/TestSeriesMatrixConfiguration";
import Api from "./Api";

class MatrixExportConfigurationApi {
  constructor(private api: Api) {}

  public getMatrixConfiguration(requestId: string): ApiResponse<MatrixExportConfigurationResponse> {
    return this.api.get(`/test-request/v2/testrequest/${requestId}/matrixexportconfiguration`);
  }

  public updateMatrixExportConfiguration(
    requestId: string,
    data: TestRequestMatrixExportConfigurationRequest,
  ): ApiResponse<MatrixConfigurationResponse> {
    return this.api.put(`/test-request/v2/testrequest/${requestId}/matrixexportconfiguration`, data);
  }

  public getTestSeriesMatrixExportConfiguration(
    testSeriesId: number,
    version: number,
  ): ApiResponse<MatrixExportConfigurationResponse> {
    return this.api.get(`/test-request/v2/test-series/${testSeriesId}/version/${version}/matrixexportconfiguration`);
  }

  public updateTestSeriesMatrixExportConfiguration(
    testSeriesId: number,
    version: number,
    data: TestSeriesMatrixExportConfigurationRequest,
  ) {
    return this.api.put(
      `/test-request/v2/test-series/${testSeriesId}/version/${version}/matrixexportconfiguration`,
      data,
    );
  }
}

export default MatrixExportConfigurationApi;
